<template>
  <div>
    <div class="title">
      <button
        class="qiehuan"
        :class="tableType == 1 ? 'ac' : ''"
        @click="changeTable(1);"
      >
        常规资料
      </button>
      <button
        class="qiehuan"
        :class="tableType == 2 ? 'ac' : ''"
        @click="changeTable(2);"
      >
        评测资料
      </button>
    </div>
    <div class="block">
      <el-date-picker
        v-model="value1"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <div>
        展示最近一周
        <select
          v-model="build_type"
          name="选择楼盘类型"
          @change="filterHandler2();"
        >
          <option value="住宅"> 住宅</option>
          <option value="公寓"> 公寓</option>
        </select>
      </div>
      <!--
        <div class="persontable">
          <div style="width:50%">
            <el-table :data="user" >
            <el-table-column label="主要人员" width="100">
              <template slot-scope="{ row,$index }">
                <el-input v-model="user[$index].mainUser"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="辅助人员" width="100">
              <template slot-scope="{ row ,$index}">
                <el-input v-model="user[$index].secoendUser"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="负责地区" width="500">
              <template slot-scope="{ row }">
                <el-tag
                  :key="index"
                  v-for="(tag, index) in row.area"
                  :disable-transitions="false"
                >
                  {{ tag }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
          </div>

        </div>
      -->
    </div>
    <!-- :span-method="merge" -->
    <!-- @filter-change="filterChange" -->
    <SjAndYuny
      :tableHeight="tableHeight"
      :person="person"
      :finishCount="finishCount"
      :build_type="build_type"
      :tableType="tableType"
      :districts="districts"
      :userAll="userAll"
      :city="city"
      @data-updated="updateParentData"
    >
    </SjAndYuny>
    <div v-show="tableType == 2">
      <el-table
        :data="person"
        :cell-style="setStyle2"
        :max-height="tableHeight"
      >
        <el-table-column
          label="人员"
          prop="user"
          :filters="userAll"
          :filter-method="filterHandler1"
        >
          <template slot-scope="{ row }">
            <div>{{ "主要人员:" + row.fuUser }}</div>
            <br />
            <div>{{ "辅助人员:" + row.user }}</div>
          </template>
        </el-table-column>
        <el-table-column label="楼盘数据">
          <el-table-column
            label="城区"
            prop="district"
            :filters="districts"
            :filter-method="filterHandler1"
          >
          </el-table-column>
          <el-table-column label="楼盘" prop="real_estate_name">
          </el-table-column>
          <el-table-column
            label="销售状态"
            :filters="[
              { text: '在售', value: '在售' },
              { text: '待首开', value: '待首开' }
            ]"
            :filter-method="filterHandler1"
            prop="real_status"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column label="综合数据">
          <el-table-column
            label="综合完整度"
            :filters="[
              { text: '达标', value: '达标' },
              { text: '不达标', value: '不达标' }
            ]"
            :filter-method="filterHandler111"
            prop="all_tagepc"
            sortable
          >
          </el-table-column>
        </el-table-column>
        <el-table-column label="评测数据">
          <el-table-column
            label="日照"
            :filters="[
              { text: '有', value: '有' },
              { text: '无', value: '无' }
            ]"
            :filter-method="filterHandler11"
            prop="rz"
          >
          </el-table-column>
          <el-table-column
            label="户型"
            :filters="[
              { text: '有', value: '有' },
              { text: '无', value: '无' }
            ]"
            :filter-method="filterHandler11"
            prop="hx"
          >
          </el-table-column>
          <el-table-column
            label="楼栋"
            :filters="[
              { text: '有', value: '有' },
              { text: '无', value: '无' }
            ]"
            :filter-method="filterHandler11"
            prop="ld"
          >
          </el-table-column>
          <el-table-column
            label="景观"
            :filters="[
              { text: '有', value: '有' },
              { text: '无', value: '无' }
            ]"
            :filter-method="filterHandler11"
            prop="jg"
          >
          </el-table-column>
          <el-table-column
            label="噪音"
            :filters="[
              { text: '有', value: '有' },
              { text: '无', value: '无' }
            ]"
            :filter-method="filterHandler11"
            prop="noise"
          >
          </el-table-column>
          <el-table-column
            label="一房一价"
            :filters="[
              { text: '有', value: '有' },
              { text: '无', value: '无' }
            ]"
            :filter-method="filterHandler11"
            prop="fj"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column label="3D数据">
          <el-table-column
            label="3D户型分布"
            prop="hxfb"
            :filters="[
              { text: '有', value: '有' },
              { text: '无', value: '无' }
            ]"
            :filter-method="filterHandler11"
          >
          </el-table-column>
          <el-table-column
            label="3D评测模型"
            :filters="[
              { text: '有', value: '有' },
              { text: '无', value: '无' }
            ]"
            :filter-method="filterHandler11"
            prop="model_3D"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column label="VR数据">
          <el-table-column
            label="航拍"
            prop="hp"
            :filters="[
              { text: '有', value: '有' },
              { text: '无', value: '无' }
            ]"
            :filter-method="filterHandler11"
          >
          </el-table-column>
          <el-table-column
            label="样板房"
            :filters="[
              { text: '有', value: '有' },
              { text: '无', value: '无' }
            ]"
            :filter-method="filterHandler11"
            prop="ybfvr"
          >
          </el-table-column>
          <el-table-column
            label="样板房标注"
            :filters="[
              { text: '有', value: '有' },
              { text: '无', value: '无' }
            ]"
            :filter-method="filterHandler11"
            prop="ybfbz"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column label="积分"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {
        杭州: [
          {
            mainUser: "宋建平",
            secoendUser: "郭慧敏",
            area: ["临安区", "拱墅区", "钱塘区"]
          },
          {
            mainUser: "徐嘉琳",
            secoendUser: "敖鸿波",
            area: ["富阳区", "西湖区", "上城区", "临平区"]
          },
          {
            mainUser: "刘梦恬",
            secoendUser: "曲文龙",
            area: ["萧山区", "滨江区", "余杭区"]
          }
        ],
        苏州: [
          {
            mainUser: "宋建平",
            secoendUser: "暂无",
            area: ["昆山市", "吴江区"]
          },
          {
            mainUser: "徐嘉琳",
            secoendUser: "暂无",
            area: ["高新区", "相城区"]
          },
          {
            mainUser: "刘梦恬",
            secoendUser: "暂无",
            area: ["工业园区", "姑苏区", "吴中区"]
          }
        ]
      },
      districts: [],
      userAll:[],
      tableHeight: 0,
      city:'',
      style1sus: "background-color: #C7FFA2",
      style1fat: "background-color: #FFA2A2",
      finishCount: 85,
      build_type: "住宅",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      value1: "",
      tableType: 1,
      person: [],
    };
  },
  mounted() {
    // console.log(this.tableHeight);
    this.getlist1();
    this.$nextTick(() => {
      this.tableHeight = document.body.clientHeight - 100;
    });
    window.onresize = () => {
      this.tableHeight = document.body.clientHeight - 100;
    };
  },
  methods: {
    changeTable(count) {
      this.tableType = count;
      this.value1 = "";
    },
    filterChange(filters) {
      let list = this.person.filter(item => {
        if (filters.hx[0]) {
          if (filters.hx[0] == "无") {
            return item.hx === filters.hx[0];
          } else {
            return item.hx !== "无";
          }
        } else {
          return true;
        }
      });
      this.shaixuan(list);
      // console.log(filters, filters.hx[0]);
    },
    getlist1() {
      this.$open();
      this.$axios
        .get(this.$url_prefix + "getziliao", {
          params: {
            build_type: this.build_type
          }
        })
        .then(res => {
          console.log(res);
          this.$close();
          this.shaixuan(res.data.data);
        })
        .catch(() => {
          this.$close();
        });
    },
    shaixuan(person) {
      let aaa = person;
      // console.log(aaa);
      let map = {};
      let city = this.$store.state.Counter.city;
      this.city = this.$store.state.Counter.city
      let linan = [];
      let districts = [];
      let user = new Set()
      let userAll = []
      for (var item of aaa) {
        if (this.user[city][0].area.includes(item.district)) {
          item.user = this.user[city][0].secoendUser;
          user.add(this.user[city][0].mainUser)
          item.fuUser = this.user[city][0].mainUser;
          if (!map[item.district]) {
            map[item.district] = [item];
          } else {
            map[item.district].push(item);
          }
        } else if (this.user[city][1].area.includes(item.district)) {
          item.user = this.user[city][1].secoendUser;
          user.add(this.user[city][1].mainUser)
          item.fuUser = this.user[city][1].mainUser;
          if (!map[item.district]) {
            map[item.district] = [item];
          } else {
            map[item.district].push(item);
          }
        } else if (this.user[city][2].area.includes(item.district)) {
          item.user = this.user[city][2].secoendUser;
          user.add(this.user[city][2].mainUser)
          item.fuUser = this.user[city][2].mainUser;
          if (!map[item.district]) {
            map[item.district] = [item];
          } else {
            map[item.district].push(item);
          }
        }
      }
      let all = Object.values(map);
      let districtsAll = Object.keys(map);
      user = Array.from(user)
      // console.log(user)
      for (let item of all) {
        linan = linan.concat(item);
      }
      for (let item of districtsAll) {
        districts = districts.concat({
          text: item,
          value: item
        });
      }
      for (let item of user) {
        userAll = userAll.concat({
          text: item,
          value: item
        });
      }
      this.person = linan;
      this.districts = districts;
      this.userAll = userAll
    },
    
    filterHandler1(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    filterHandler2() {
      this.getlist1();
    },
    filterHandler11(value, row, column) {
      const property = column["property"];
      if (value == "无") {
        return row[property] === value;
      } else {
        return row[property] !== "无";
      }
    },
    filterHandler111(value, row, column) {
      const property = column["property"];
      if (this.build_type == "住宅") {
        if (value == "达标") {
          if (row[property].split("%")[0] * 1 > 85) {
            return true;
          }
        } else if (value == "不达标") {
          if (row[property].split("%")[0] * 1 < 85) {
            return true;
          }
        }
      } else if (this.build_type == "公寓") {
        if (value == "达标") {
          if (row[property].split("%")[0] * 1 > 80) {
            return true;
          }
        } else if (value == "不达标") {
          if (row[property].split("%")[0] * 1 < 80) {
            return true;
          }
        }
      }
    },
    updateParentData(updatedData) {
      // 更新父组件中的数据
      this.parentData = updatedData;
    },
    setStyle2({ row, column, rowIndex, columnIndex }) {
      const property = column["property"];
      if (columnIndex == 4) {
        if (row[property].split("%")[0] * 1 > 85) {
          return this.style1sus;
        }
      } else if (columnIndex == 5) {
        if (row[property] !== "无") {
          return this.style1sus;
        }
      } else if (columnIndex == 6) {
        if (row[property] !== "无") {
          if (row[property].split("个")[0] * 1 >= 1) {
            return this.style1sus;
          }
        }
      } else if (columnIndex == 7) {
        if (row[property] !== "无") {
          return this.style1sus;
        }
      } else if (columnIndex == 8) {
        if (row[property] !== "无") {
          return this.style1sus;
        }
      } else if (columnIndex == 9) {
        if (row[property] !== "无") {
          return this.style1sus;
        }
      } else if (columnIndex == 10) {
        if (row[property] !== "无") {
          if (row[property].split("栋")[0] * 1 >= 1) {
            return this.style1sus;
          }
        }
      } else if (columnIndex == 11) {
        if (row[property] !== "无") {
          return this.style1sus;
        }
      } else if (columnIndex == 12) {
        if (row[property] !== "无") {
          return this.style1sus;
        }
      } else if (columnIndex == 13) {
        if (this.city=='杭州'&&row[property].split("个")[0] * 1 >= 1) {
          return this.style1sus;
        }
      } else if (columnIndex == 14) {
        if (this.city=='杭州'&&row[property].split("个")[0] * 1 >= 1) {
          return this.style1sus;
        }
      } else if (columnIndex == 15) {
        if (this.city=='杭州'&&row[property].split("个")[0] * 1 >= 1 || row[property] == "毛坯") {
          return this.style1sus;
        }
      }
      if(this.city=='杭州'){
        if (columnIndex > 3) return this.style1fat;
      }else{
        if (columnIndex > 3&&columnIndex!==13&&columnIndex!==14&&columnIndex!==15&&columnIndex!==16) return this.style1fat;
      }
      
    }
  }
};
</script>

<style>
/* 对于样式的切换的话，我们可以动态绑定一个class或者动态绑定样式，用三元判别来进行判断 */
.title {
  /* font-size:0;如果多个buton组件建有间距，可以设置布局或者使用sont-size为0来取消间距 */
  display: flex;
  justify-content: center;
}
.title .qiehuan {
  border: 1px solid;
}
.ac {
  background-color: rgb(127, 127, 192);
}
.persontable {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/page/shujuCount.vue